import { IUsers, IUsersItems, UsersReponseType, UserAddRequestType } from '@/entity/Settings/Users.types';
import { IUsersCosmetologist, IUsersCosmetologistItem, UserCosmetologistAddRequestType, UsersCosmetologistResponseType } from '@/entity/Settings/UserCosmetologist.types';
import { ResponseDataType } from '@/form/form.types';
import Api from '@/repository/api';
import { ICosmetologistUsersRepository } from '@/repository/Settings/Users/CosmetologistUserRepository.types';
import { UserCosmetologist } from '@/entity/Settings/UserCosmetologist';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { getResponse, getResponseQs } from '@/repository/Helpers/repositoryLib';

export class CosmetologistUsersRepository implements ICosmetologistUsersRepository {
    async fetchAll(data?: FormData): Promise<IUsersCosmetologist> {
        console.log('SettingsUserRepository fetchAll');
        const response = await getResponse(`/user_cosmetologist/get`, data);
        const responseData = response.data as UsersCosmetologistResponseType;
        return new UserCosmetologist(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<IUsersCosmetologistItem> {
        const response = await getResponseQs(`/user_cosmetologist/get`, data);
        const responseData = response.data as UsersCosmetologistResponseType;
        return new UserCosmetologist(responseData).data[0];
    }
    async create(data: UserCosmetologistAddRequestType): Promise<ResponseDataType> {
        const res = await Api.post('/user_cosmetologist/registrate', data);
        return res.data;
    }
}
